import Footer from "../../components/footer/footer"
import Header from "../../components/header/header"
import LoginSection from "../../components/login/login";
import SearchModel from "../../components/search_model/search";

const Login = () => {
    return (
        <>
            <Header />
            <LoginSection/>
            <Footer />
            <SearchModel/>
        </>
    )
}

export default Login